(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["delivery-estimate"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('delivery-estimate')) {
    class DeliveryEstimate extends HTMLElement {
      connectedCallback() {
        const days = Number(this.dataset.businessDays);
        const line = this.querySelector('[data-delivery-date-line]');
        const output = this.querySelector('[data-delivery-date]');
        if (!line || !output || !Number.isFinite(days) || days <= 0) return;

        const date = new Date();
        let added = 0;
        // Guard keeps the loop finite even with a bad setting.
        for (let guard = 0; added < days && guard < 60; guard += 1) {
          date.setDate(date.getDate() + 1);
          const weekday = date.getDay();
          if (weekday !== 0 && weekday !== 6) added += 1;
        }

        try {
          const locale = document.documentElement.lang || 'en-US';
          output.textContent = new Intl.DateTimeFormat(locale.startsWith('en') ? 'en-US' : locale, {
            weekday: 'short',
            month: 'short',
            day: 'numeric',
          }).format(date);
        } catch {
          return;
        }
        line.hidden = false;
      }
    }

    customElements.define('delivery-estimate', DeliveryEstimate);
  }
  } catch(e) { console.error(e); }
})();

})();
